export const agentConstants = {
  OPEN_AGENT_CHAT: 'OPEN_AGENT_CHAT',
  CLOSE_AGENT_CHAT: 'CLOSE_AGENT_CHAT',
  CLEAR_AGENT_DATA: 'CLEAR_AGENT_DATA',
  SET_FLOW_GREETING_MESSAGE: 'SET_FLOW_GREETING_MESSAGE'
};
